const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const GA_SCRIPT_SRC = "https://www.googletagmanager.com/gtag/js";

let hasInitialized = false;
let lastTrackedPageKey = null;

function getPagePath() {
  if (typeof window === "undefined") return "/";
  return window.location.pathname || "/";
}

export function initAnalytics() {
  if (
    hasInitialized ||
    !GA_MEASUREMENT_ID ||
    typeof window === "undefined" ||
    typeof document === "undefined"
  ) {
    return false;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  const existingScript = document.querySelector(
    `script[src="${GA_SCRIPT_SRC}?id=${GA_MEASUREMENT_ID}"]`,
  );

  if (!existingScript) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `${GA_SCRIPT_SRC}?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
  });

  hasInitialized = true;
  return true;
}

export function trackPageView({ pageTitle } = {}) {
  if (!GA_MEASUREMENT_ID || typeof window === "undefined" || !window.gtag) {
    return;
  }

  const pagePath = getPagePath();
  const pageKey = `${window.location.href}::${pagePath}`;
  if (lastTrackedPageKey === pageKey) {
    return;
  }

  lastTrackedPageKey = pageKey;

  window.gtag("event", "page_view", {
    page_title: pageTitle || document.title,
    page_location: window.location.href,
    page_path: pagePath,
  });
}

export function trackEvent(eventName, params = {}) {
  if (!GA_MEASUREMENT_ID || typeof window === "undefined" || !window.gtag) {
    return;
  }

  window.gtag("event", eventName, params);
}
